import { Component, OnInit } from '@angular/core';
import {KeycloakService} from "../shared/keycloak.service";
import {UserModel} from "../model/user.model";
import {UserService} from "../shared/user.service";

@Component({
    selector: 'app-nav',
    templateUrl: './nav.component.html',
    styleUrls: ['./nav.component.scss'],
    standalone: false
})
export class NavComponent implements OnInit {

  isAdmin = false;
  tokenMissingError = "Missing HTTP_AUTHORIZATION header from request!";
  user: UserModel;

  constructor(
    private kc: KeycloakService,
    private service: UserService
  ) { }

  ngOnInit(): void {
    this.user = this.service.currentUser;
    this.isAdmin = this.user.isAdmin();
  }

  onLogoutClick() {
    this.kc.logout();
  }

}
